import React, { forwardRef, useImperativeHandle, useEffect } from 'react';

const Modal = forwardRef(({ tailwindcss, title, handleSubmit, children, pageType, isSeller = true, message }, ref) => {
  const [showModal, setShowModal] = React.useState(false);

  const clonedChildren = React.cloneElement(children, { setShowModal });

  useEffect(() => {
    if (showModal && !isSeller) {
      setTimeout(() => {
        alert(message);
      }, 500);
    }
  }, [showModal, isSeller]);

  useImperativeHandle(ref, () => ({
    setShowModal,
  }));

  return (
    <>
      <button
        className={tailwindcss || 'border rounded-lg px-4 py-2 bg-greyd-grey text-pioneer font-semibold'}
        type="button"
        onClick={() => setShowModal(true)}
      >
        {title}
      </button>
      {showModal ? (
        <>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative w-2/3 my-6 mx-auto">
              {/* max-w-3xl */}
              {/* content */}
              <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-greyd-grey outline-none focus:outline-none">
                {/* header */}
                <div className="flex items-start justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                  <h3 className="text-3xl font-semibold text-pioneer">{title}</h3>
                  <button
                    className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                    onClick={() => setShowModal(false)}
                  >
                    <span className="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                      ×
                    </span>
                  </button>
                </div>
                <div className="relative p-6 flex-auto overflow-auto h-120 mb-4">{clonedChildren}</div>
                <div className="flex items-center justify-end p-6 border-t border-solid border-slate-200 rounded-b">
                  <button
                    className="text-pioneer background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                    type="button"
                    onClick={() => {
                      if (!isSeller) {
                        return alert('정보를 입력해주세요');
                      }

                      setShowModal(false);
                    }}
                  >
                    닫기
                  </button>
                  {pageType !== 'order' ? (
                    <button
                      className="bg-yellow-400 text-greyd-grey active:bg-yellow-500 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                      type="button"
                      onClick={() => {
                        handleSubmit();
                      }}
                    >
                      {title}
                    </button>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black" />
        </>
      ) : null}
    </>
  );
});

Modal.displayName = 'Modal';
export default Modal;
